import { defaultClient } from '@mint-sdk/api-core';

import {
  CheckFlowStatusQuerySchema,
  CreateRequestRequestSchema,
  ExecutionItemResponseSchema,
  CheckFlowStatusResponseSchema,
  SendApproverDecisionRequestSchema,
  SendApproverDecisionUrlParamsSchema,
  NotifyPartiesResponseSchema,
  NotifyPartiesUrlParamsSchema,
} from './schemas.js';

export const createRequest = defaultClient.mutation({
  url: 'approval-service/v2/requests/' as const,
  method: 'POST',
  requestSchema: CreateRequestRequestSchema,
  responseSchema: ExecutionItemResponseSchema,
});

export const withdrawRequest = defaultClient.mutation({
  url: 'approval-service/v2/requests/$requestId/withdraw' as const,
  method: 'POST',
  responseSchema: ExecutionItemResponseSchema,
});

export const getRequest = defaultClient.query({
  method: 'GET',
  url: 'approval-service/v2/requests/$requestId' as const,
  responseSchema: ExecutionItemResponseSchema,
});

export const checkFlowStatus = defaultClient.query({
  method: 'GET',
  url: 'approval-service/v2/requests/check-status' as const,
  querySchema: CheckFlowStatusQuerySchema,
  responseSchema: CheckFlowStatusResponseSchema,
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
});

export const sendApproverDecision = defaultClient.mutation({
  url: 'approval-service/v2/requests/$requestId/$status' as const,
  method: 'POST',
  urlParamsSchema: SendApproverDecisionUrlParamsSchema,
  requestSchema: SendApproverDecisionRequestSchema,
  responseSchema: ExecutionItemResponseSchema,
});

export const notifyParties = defaultClient.mutation({
  url: 'approval-service/v2/requests/$requestId/notify-parties/' as const,
  method: 'POST',
  urlParamsSchema: NotifyPartiesUrlParamsSchema,
  responseSchema: NotifyPartiesResponseSchema,
});
